import apiSlice from './apiSlice';

export const { useGetWebStreamURLQuery } = apiSlice;

export * as webStreamUtils from './utils';
